import EventPublisher from "../utils/EventPublisher";
import UIInteractionEvents from "../constants/events/UIInteractionEvents";
import FileUploadAPIClient from "../client/FileUploadAPIClient";

class FileUploadActions {

    constructor() {
        this.fileUploadApiClient = new FileUploadAPIClient();
        EventPublisher.subscribe(UIInteractionEvents.FILE_UPLOAD_STARTED, this.handleRequestFileUrl);

    }

    handleRequestFileUrl = (topic, data) => {
        for (let i = 0; i < data.files.length ; i++) {
            const image = data.files.item(i);
            this.fileUploadApiClient.createFileUploadUrl(image);
        }
    };

}

export default new FileUploadActions();
